module.exports = __webpack_public_path__ + "img/logo_torreon.c7895f01.png";